(() => {
  const root = document.querySelector('[data-wo-modals]');
  if (!root) return;

  const FOCUSABLE_SELECTORS = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let activeModal = null;
  let lastActive = null;

  function getModal(key) {
    return document.getElementById(`wo-modal-${key}`);
  }

  function getFocusableElements(modal) {
    return Array.from(modal.querySelectorAll(FOCUSABLE_SELECTORS)).filter((el) => {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function openModal(key, openerEl) {
    const modal = getModal(key);
    if (!modal) return;

    // close any existing modal
    if (activeModal && activeModal !== modal) {
      closeModal(activeModal, false);
    }

    activeModal = modal;
    lastActive = openerEl || document.activeElement;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('wo-modal-open');
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      const closeBtn = modal.querySelector('.wo-modal__close');
      const focusable = getFocusableElements(modal);

      if (closeBtn) {
        closeBtn.focus();
      } else if (focusable.length) {
        focusable[0].focus();
      } else {
        modal.focus();
      }
    });
  }

  function closeModal(modal, returnFocus = true) {
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('wo-modal-open');
    document.body.style.overflow = '';

    if (returnFocus && lastActive && typeof lastActive.focus === 'function') {
      lastActive.focus();
    }

    if (activeModal === modal) {
      activeModal = null;
    }

    lastActive = null;
  }

  document.addEventListener('click', (e) => {
    // open
    const openTrigger = e.target.closest('[data-wo-modal-open]');
    if (openTrigger) {
      const key = openTrigger.getAttribute('data-wo-modal-open');
      if (!key) return;

      e.preventDefault();
      openModal(key, openTrigger);
      return;
    }

    // close
    const closeTrigger = e.target.closest('[data-wo-modal-close]');
    if (closeTrigger) {
      const modal = closeTrigger.closest('.wo-modal');
      closeModal(modal, true);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!activeModal) return;

    // Escape closes
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal(activeModal, true);
      return;
    }

    // Focus trap
    if (e.key !== 'Tab') return;

    const focusable = getFocusableElements(activeModal);

    if (!focusable.length) {
      e.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const current = document.activeElement;

    if (e.shiftKey) {
      if (current === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (current === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();